import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import { SportsReq, SportsRes } from '@/types/api/hall/sports';

export const getSportsList = (params?: SportsReq) => get<SportsRes>('/hall/v1/sports', { params });

export const useSportsList = createApiQuery(getSportsList, (params?: SportsReq) => ['sportsList', params]);
